import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed, rst, msg, data, isLoading } = useRequest({
    url: '/api/orders',
    name: 'PUT_CUSTOMER_ORDER',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed, msg];
});
